import { ALCHEMISTEN } from 'da-three';

function createErrorObject(code, error) {

    // if we need to create Errors -> do that here // TODO put this somewhere else
    var errRes = { code, error };
    switch (code) {
        case "no_webgl":
            errRes.className = "loading_screen_snow";
            errRes.message = "no webgl supported";
            errRes.humanMessage = `WebGl wird von Ihrem Browser nicht unterstützt. <br>
            <a href="www.google.de/chrome">Google Chrome herunterladen</a>`;
            break;
        case "invalid_project": // -1
            errRes.message = "project id is invalid";
            errRes.humanMessage = "404 - Angegebenes Projekt exisitiert nicht!";
            break;
        case "no_project_id":
            errRes.message = "no project id was specified";
            errRes.humanMessage = "404 - Angegebenes Projekt exisitiert nicht! (Keine Projektnummer angegeben)";
            break;
        case "invalid_json":
            errRes.message = "result from server was no valid json";
            errRes.humanMessage = "Es gab einen Fehler beim Laden der Szene!";
            break;
        case "network_error":
            errRes.message = "network request error";
            errRes.humanMessage = "Konfiguration konnte nicht geladen werden!";
            break;
        default:
            errRes.message = "error code '" + code + "' has no detailed error message";
    }

    return errRes;
}


function getJSONFromURL(url, callback, progress) {
    ALCHEMISTEN.instance.auth.authorizedRequest(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }, callback, progress);
}



function lookupOrReplace(key, keyList) {
    if (keyList[key] !== undefined) {
        return keyList[key];
    } else {
        return key;
    }
}



function httpRequest(url, options, callback, onProgress) {
    if (window.WEBGL_APP_MODE) {
        console.log("APP_MODE", url);

        const payload = { type: 'getData', url };
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify(payload));
        } else {
            window.postMessage({ _debug: true, ...payload });
        }

        new Promise((res, rej) => {
            window.CONTENT_VIEWER.requests[url] = res;
        }).then(dataUri => {

            const parts = dataUri.split(/data:[\w\-\+\/]+;base64,(.*)/);
            if (parts.length > 0) {
                const decoded = atob(parts[1]);
                // json
                if (/^\{|\[/.test(decoded)) {
                    callback({ payload: JSON.parse(decoded) });
                } else {
                    callback({ payload: decoded });
                }
            } else {
                callback({ error: { code: 1000, message: 'Unexpected Local API response' } });
            }
        });
        return;
    } else {
        var req = new XMLHttpRequest();
        req.open(options.method, url);

        if (options !== undefined) {
            if (options.headers) {
                Object.getOwnPropertyNames(options.headers).forEach((prop) => {
                    req.setRequestHeader(prop, options.headers[prop]);
                });
            }
        }
        let auth = localStorage.getItem('DAStudioAuthToken');
        if (auth !== null) {
            req.setRequestHeader('Authorization', 'Bearer ' + auth);
            options.headers['Authorization'] = 'Bearer ' + auth;
        }

        req.onreadystatechange = function () {
            if (req.readyState === 4) {
                if (req.status >= 200 && req.status < 400) {
                    if (callback !== undefined) {
                        if (req.getResponseHeader("Content-Type") === 'application/json') {
                            callback({ payload: JSON.parse(req.responseText) });
                        } else {
                            callback({ payload: req.responseText });
                        }
                    }
                } else if (req.status >= 400) {
                    callback({ error: JSON.parse(req.responseText) });
                }
            }
        };

        if (typeof onProgress === 'function') {
            req.onprogress = function (pe) {
                onProgress(pe);
            };
        }

        req.onerror = (error) => {
            callback({ error: error });
        };

        if (options.payload !== undefined && typeof options.payload === 'object')
            options.payload = JSON.stringify(options.payload);

        req.send(options.payload);
    }
}

function randomString(length) {
    const alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let str = "";
    for (let i = 0; i < length; i++) {
        str += alphabet[(Math.random() * alphabet.length) | 0];
    }

    return str;
}

function arrayBufferToBase64(buffer) {
    let binary = '';
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

// EXPORTS
module.exports = {
    createErrorObject,
    getJSONFromURL,
    lookupOrReplace,
    httpRequest,
    randomString,
    arrayBufferToBase64
};


// WEBPACK FOOTER //
// ./src/js/util/Helper.js